// src/pages/Menu.tsx
import { useEffect, useState } from "react";
import api from "../api/axios";
import Sidebar from "../components/Sidebar";
import DashboardTopbar from "../components/DashboardTopbar";
import { Link } from "react-router-dom";

interface MenuItem {
  id: number;
  name: string;
  description: string;
  price: number;
  image: string;
}

const Menu = () => {
  const [items, setItems] = useState<MenuItem[]>([]);

  const fetchMenuItems = async () => {
    try {
      const res = await api.get<MenuItem[]>("/menu-items/");
      setItems(res.data);
    } catch (error) {
      console.error("Failed to fetch menu items", error);
    }
  };

  const handleDelete = async (id: number) => {
    try {
      await api.delete(`/menu-items/${id}/`);
      fetchMenuItems();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  useEffect(() => {
    fetchMenuItems();
  }, []);

  return (
    <div className="flex min-h-screen bg-gray-100 text-black">
      <Sidebar />
      <div className="flex flex-col flex-1">
        <DashboardTopbar
          logoUrl="/logo.png"
          name="FullPlateNow Restaurant"
          address="123 Main St, Springfield"
        />
        <main className="p-8">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold">Your Menu</h1>
            <Link
              to="/dashboard/menu-upload"
              className="bg-black text-white px-4 py-2 rounded hover:bg-gray-900"
            >
              Upload New Item
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {items.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-lg shadow p-4 flex flex-col"
              >
                {item.image && (
                  <img
                    src={item.image}
                    alt={item.name}
                    className="rounded h-40 w-full object-cover mb-3"
                  />
                )}
                <h2 className="font-semibold text-lg">{item.name}</h2>
                <p className="text-sm text-gray-600 mb-2">{item.description}</p>
                <p className="text-sm font-medium text-gray-700">
                  $
                  {typeof item.price === "number"
                    ? item.price.toFixed(2)
                    : parseFloat(item.price).toFixed(2)}
                </p>

                <button
                  onClick={() => handleDelete(item.id)}
                  className="text-red-600 text-sm hover:underline mt-auto self-start"
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Menu;
